module.exports = __webpack_public_path__ + "static/img/card_1_2.d5d15d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_1_2.png
// module id = octe
// module chunks = 0